module.exports = __webpack_public_path__ + "static/img/server.17b1545d.jpg";